import React from "react";

export function Melble() {
  return (
    <span className="font-bold">
      ME<span className="text-green-600">L</span>B
      <span className="text-green-600">L</span>E
    </span>
  );
}
